import React from 'react';
import { Card, Progress, Tag } from 'antd';
import { CsvImportInterface } from "src/store/callrecorder/csvImportsSlice";

const _Details = ({ record }: { record: CsvImportInterface | undefined }) => {
  if (!record) return null;

  return (
    <>
      <Card className='v-mb-20'>
        <div
          className='v-content-label'
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: 4
          }}
        >
          Processed: {record.processed_rows} / {record.total_rows}
        </div>

        <Progress
          percent={record.progress || 0}
          status={record.status === 'completed' ? 'success' : record.status === 'failed' ? 'exception' : 'active'}
          size="default"
          style={{ width: '100%' }}
        />

        {record.error_rows > 0 && (
          <div style={{ marginTop: 8, fontSize: 13 }}>
            Errors: <Tag color="error">{record.error_rows}</Tag>
          </div>
        )}
      </Card>
    </>
  )
}

export default _Details;
